import { restreamingToggled } from 'features/restreamer/actions';
import { call, put, select } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectFeatureFlag } from 'features/feature-set/featuresSlice';

export function* onToggleRestreamingCommandSaga(newState?: boolean) {
  const controlEnabled: boolean = yield select(selectFeatureFlag, 'restreaming');

  if (!controlEnabled) {
    yield call(
      eventBus.notAllowedError,
      "Restreaming disabled. You'll need to edit this room's properties to restream sessions in this room",
      'restreaming'
    );

    return;
  }

  const canToggleRestreaming: boolean = yield call(hasPermissionsSaga, PermissionTypes.restreaming);

  if (!canToggleRestreaming) {
    yield call(
      eventBus.forbiddenActionError,
      'Forbidden action. This participant is not allowed to control restreaming',
      'restreaming'
    );

    return;
  }

  yield put(restreamingToggled(newState));
}
